'use client';

import * as React from 'react';
import * as RadixSwitch from '@radix-ui/react-switch';
import clsx from 'clsx';
import Image from 'next/image';
import switchBallImg from '@/assets/images/common/switch-ball.png';
import switchBallOffImg from '@/assets/images/common/switch-ball-off.png';
import switchActiveBgImg from '@/assets/images/common/switch-active.png';
import switchInactiveBgImg from '@/assets/images/common/switch-detive.png';

export interface SwitchProps extends React.ComponentPropsWithoutRef<typeof RadixSwitch.Root> {
  className?: string;
}

export const Switch: React.FC<SwitchProps> = ({ className, ...props }) => {
  // 从 props 中获取 checked 状态，如果不存在则默认为 false
  const isChecked = props.checked ?? false;

  return (
    <RadixSwitch.Root
      {...props}
      className={clsx(
        'relative inline-flex items-center rounded-full transition-all duration-200',
        'h-[1.4375rem] w-[2.5625rem] focus:outline-none',
        className,
      )}
      style={{
        backgroundSize: '100% 100%',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundImage: `url(${isChecked ? switchActiveBgImg.src : switchInactiveBgImg.src})`,
      }}
    >
      <RadixSwitch.Thumb
        className={clsx(
          'relative flex items-center justify-center h-[1.1875rem] w-[1.1875rem] rounded-full shadow transition-transform duration-200',
          'translate-x-[1px] data-[state=checked]:translate-x-[1.25rem]'
        )}
      >
        <Image
          src={isChecked ? switchBallImg : switchBallOffImg}
          alt=""
          fill
          className=" translate-y-[0.4px] w-[2.375rem] h-10"
        />
      </RadixSwitch.Thumb>
    </RadixSwitch.Root>
  );
};

export default Switch;


